import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import Emitter from 'tiny-emitter/instance';
import { isMobile } from 'mobile-device-detect';
import LazyLoad from 'vanilla-lazyload';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        window.scroll = this.scroll = new LocomotiveScroll({ lerp: isMobile ? 0.2 : 0.1, el: this.el, smooth: true , touchMultiplier: 3,smartphone: { smooth: false }, tablet: { smooth: false }, getDirection: true });
        this.scroll.on('call', this.onCall.bind( this ) );
        this.scroll.on('scroll', this.onScroll.bind( this ) );
        this.y = 0;

        this.lazy = new LazyLoad({ elements_selector : '[data-scroll-call="toggleLazy,Scroll"]', container: this.el });
    }

    onCall(func, way, obj, id) {
        this.call(func[0], { way, obj, direction: this.direction }, func[1], func[2]);
    }

    onScroll( args ){
        Emitter.emit('page-scroll', args );
        this.y = args.scroll.y;
        this.direction = args.direction;
    }

    destroy() {
        this.scroll.destroy();
    }

    scrollTo( args ){
        this.scroll.scrollTo( args.target, args.options || {} );
    }

    stop(){
        this.scroll.stop();
    }

    start(){
        this.scroll.start();
    }

    update(){
        if( ! this.scroll ) return;
        this.scroll.update();
    }

    toggleLazy( args ){
        return;
        let el = args.obj.el;
        let src = el.dataset.src;
        if( src ) {
            el.removeAttribute( 'data-src' );
            el.classList.add( 'is-loading' );
            let image = new Image();
            image.onload = () => {
                el.tagName === "IMG" ? el.src = src : el.style.backgroundImage = `url(${src})`;
                image.remove();
                el.classList.add( 'is-loaded' );
                let parent = el.closest( '.o-image' );
                if( parent ) parent.classList.add( 'is-loaded' );
            };
            image.src = src;
        }
    }

    toggleVideo( args ){
        let el = args.obj.el;
        let src = el.dataset.src;
        if( src ) {
            let source= document.createElement( 'source' );
            source.src = src;
            el.appendChild( source );
            el.removeAttribute( 'data-src' );
            el.classList.add( 'is-loaded' );
        }
    }

}
